/**
 * Hook for ConfirmModal state and handlers. Extracted to keep ConfirmModal under max-lines-per-function.
 */

import { useConfirmModalStateCore, type ConfirmModalStateReturn } from "./useConfirmModalStateCore";
import type { ConfirmModalStateParams } from "./useConfirmModalStateParams";

export type { ConfirmModalStateParams } from "./useConfirmModalStateParams";

export function useConfirmModalState(props: ConfirmModalStateParams): ConfirmModalStateReturn {
	return useConfirmModalStateCore(props);
}
